import CrmFullpageContainer from './crm-fullpage-container'
export { CrmFullpageContainer }
